







































import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from './field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';

@Component({
  name: 'bpc-editable-input',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class EditableInput extends mixins(AbstractField) {
  @Prop([String, Number]) readonly value: string | number;
  @Prop(Boolean) readonly loading: boolean;

  get model(): string | number {
    return this.value;
  }
  set model(val: string | number) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  editionEnabled: boolean = false;

  onEnterKey() {
    this.$emit('enter-key');
    if (this.isFieldEnabled) {
      this.$emit('save-clicked', this.model);
    }
  }
  onEscKey() {
    this.$emit('esc-key');
    this.onCancelClicked();
  }

  get isFieldEnabled(): boolean {
    return !this.isDisabled && !this.loading && this.editionEnabled;
  }

  onEditClicked() {
    this.editionEnabled = true;
  }
  onCancelClicked() {
    this.editionEnabled = false;
  }

  onSaveClicked() {
    this.$emit('save-clicked', this.model);
  }

  // updated () { }

  // destroyed () { }
}
